// extracted by mini-css-extract-plugin
var _1 = "PostDetailPreview-module__animateUploadProgressBarWidth--Re6HO";
var _2 = "PostDetailPreview-module__animatedBackground--yDv1U";
var _3 = "PostDetailPreview-module__banner--R2oQs";
var _4 = "PostDetailPreview-module__container--YyNSN";
var _5 = "PostDetailPreview-module__editorRoot--kP6bC";
var _6 = "PostDetailPreview-module__headerContainer--kHALS";
var _7 = "PostDetailPreview-module__link--Gsjc2";
var _8 = "PostDetailPreview-module__postContent--zApcZ";
var _9 = "PostDetailPreview-module__postContentContainer--G2YzM";
var _a = "PostDetailPreview-module__statusBar--Yib4B";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "banner", _4 as "container", _5 as "editorRoot", _6 as "headerContainer", _7 as "link", _8 as "postContent", _9 as "postContentContainer", _a as "statusBar" }
